import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { checkToken } from '../store/slices/userSlice';

export const AuthInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { initialized } = useAppSelector((state) => state.user);

  useEffect(() => {
    void dispatch(checkToken());
  }, [dispatch]);

  if (!initialized) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return <>{children}</>;
};
